const Style = (theme) => ({
  // filter__width: {
  //   "& .field-width": {
  //     width: "20rem",
  //   },
  //   "& .dropdown-width": {
  //     width: "10rem",
  //   },
  // },
  // dataGrid: {
  //   width: "640px",
  // },
  profile__img__section: {
    width: "108px",
    height: "108px",
    position: "absolute",
    bottom: "-56px",
    left: "22px",
    borderRadius: "50%",
    "& .profile__img": {
      height: "100%",
      width: "100%",
      // position: "absolute",
      borderRadius: "50%",
    },
  },

  icon: {
    width: "100%",
    height: "100%",
    padding: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  checked_files_container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    borderRadius: "8px",
    background: " #D9ECFF",
    padding: "8px 16px",
  },
  // client__banner__container: {
  //   [theme.breakpoints.down("md")]: {
  //     "& .second__grid": {
  //       paddingLeft: "0",
  //       paddingTop: "2rem",
  //     },
  //   },
  // },
});
export default Style;
